<template>
  <div id="app" class="yticon">
      <router-view ></router-view>
  </div>
</template>
<script>
  export default {
    name: 'App'
  }
</script>
<style lang="scss" scoped>
  #app{

      background: #e6e6e6;
    /deep/ .el-table th{
      user-select:inherit !important;
    }
    /deep/ .tableLabelHidden{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }

      /deep/ .el-button--primary{
        margin-bottom: 10px !important;
      }
      /deep/ .el-table .warning-row {
        // background: #d7cbcb;
        background: #e6e6e6;
      }

      /deep/ .el-table .success-row {
        background: #fff;
      }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue